import React from 'react';

const MAP_PIN_POSITIONS = [
  { x: '17%', y: '42%' },
  { x: '37%', y: '63%' },
  { x: '58%', y: '46%' },
  { x: '74%', y: '67%' },
  { x: '84%', y: '36%' },
];

const MapVisual = ({ revealMeta = {} }) => {
  const mapState = revealMeta.mapState || {};
  const pins = mapState.pins?.length ? mapState.pins.slice(0, 5) : [
    { label: 'First Stop', dateLabel: 'Start' },
    { label: 'Memory', dateLabel: 'Then' },
    { label: 'Today', dateLabel: 'Now' },
  ];

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-map is-${mapState.style || 'memory-map'}${mapState.hasStops ? ' has-stops' : ' is-empty'}`}
      data-pin-count={mapState.count || pins.length}
      aria-hidden="true"
    >
      <span className="fold fold-a">
        <i />
        <i />
      </span>
      <span className="fold fold-b">
        <i />
        <i />
      </span>
      <span className="fold fold-c">
        <i />
        <i />
      </span>
      <span className="route" />
      {pins.map((pin, index) => {
        const position = MAP_PIN_POSITIONS[index] || MAP_PIN_POSITIONS[MAP_PIN_POSITIONS.length - 1];
        return (
          <span
            key={`${pin.label}_${index}`}
            className={`pin pin-${index}`}
            style={{
              '--pin-x': position.x,
              '--pin-y': position.y,
              '--pin-delay': `${320 + index * 90}ms`,
            }}
          >
            <b>{index + 1}</b>
          </span>
        );
      })}
    </span>
  );
};

export default MapVisual;
